import type { NextPage } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import styles from './button-simple.module.scss';

export type ButtonSimpleType = {
  className?: string;
  text?: string;
  iconStart?: boolean;
  iconEnd?: boolean;
  focusRing?: boolean;
  designBlendingMode: string;
  designBlendingMode1: string;
  href?: string;
  /** Variant props */
  color?: 'accent' | 'neutral';
  highContrast?: boolean;
  loading?: boolean;
  size?: 3;
  state?: string;
  variant?: 'solid ✦' | 'outline';
  /** Width control */
  fullWidth?: boolean;
  /** Disable button */
  disabled?: boolean;
  /** Button type */
  type?: 'button' | 'submit' | 'reset';
};

const ButtonSimple: NextPage<ButtonSimpleType> = ({
  className = '',
  color = 'accent',
  highContrast = false,
  loading = false,
  size = 1,
  state = 'default ✦',
  variant = 'classic',
  text = 'Search',
  iconStart = false,
  iconEnd = false,
  focusRing = false,
  designBlendingMode,
  designBlendingMode1,
  fullWidth = false,
  href,
  disabled = false,
  type = 'button',
}) => {
  const ButtonContent = () => (
    <>
      {!!focusRing && (
        <div className={styles.focusRing}>
          <div className={styles.border2} />
          <div className={styles.border1} />
        </div>
      )}
      {!!iconStart && (
        <Image
          className={styles.designBlendingMode}
          width={18}
          height={18}
          sizes="100vw"
          alt=""
          src={designBlendingMode}
        />
      )}
      <div className={styles.button}>{text}</div>
      {!!iconEnd && (
        <Image
          className={styles.designBlendingMode1}
          width={18}
          height={18}
          sizes="100vw"
          alt=""
          src={designBlendingMode1}
        />
      )}
    </>
  );

  if (href) {
    return (
      <Link
        href={href}
        className={[styles.root, className].join(' ')}
        data-color={color}
        data-highcontrast={highContrast}
        data-loading={loading}
        data-size={size}
        data-state={state}
        data-variant={variant}
        data-full-width={fullWidth}
        aria-disabled={disabled}
        onClick={disabled ? (e) => e.preventDefault() : undefined}
      >
        <ButtonContent />
      </Link>
    );
  }

  return (
    <button
      className={[styles.root, className].join(' ')}
      data-color={color}
      data-highcontrast={highContrast}
      data-loading={loading}
      data-size={size}
      data-state={state}
      data-variant={variant}
      data-full-width={fullWidth}
      disabled={disabled}
      type={type}
    >
      <ButtonContent />
    </button>
  );
};

export default ButtonSimple;
